/**
 * Filter class
 *
 * @package    DataTable
 * @author     Maxim Lukianenko <mlukianenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import FilterDate from './Filters/FilterDate';
import FilterSelect from './Filters/FilterSelect';
import FilterString from './Filters/FilterString';
import FilterComplexString from './Filters/FilterComplexString';
import FilterAutocomplete from './Filters/FilterAutocomplete';
import {
    DATA_TABLE_FILTER_TYPE_STRING,
    DATA_TABLE_FILTER_TYPE_DATE,
    DATA_TABLE_FILTER_TYPE_SELECT,
    DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
    DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_MULTI,
    DATA_TABLE_FILTER_TYPE_COMPLEX_STRING,
} from 'Constants';
import { DataTableColumnType } from 'Types';

export default class Filter extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        column: DataTableColumnType.isRequired,
        filter: PropTypes.any,
        setWhere: PropTypes.func.isRequired,
        handleSearch: PropTypes.func,
    };

    setFilter = value => {
        const {
            column: { key, relation, filterKey, operator },
            setWhere,
        } = this.props;
        setWhere(key, value, relation, filterKey, operator);
    };

    render() {
        const {
            column: {
                key,
                filterKey,
                filterValue,
                filterType,
                options,
                loadOptions,
                filterPlaceholder: placeholder,
                filterLibraryParams,
                operator,
                onChange,
                tmpFilter,
                submitOnKeyPress,
            },
            handleSearch,
            filter,
        } = this.props;

        switch (filterType) {
            case DATA_TABLE_FILTER_TYPE_STRING:
                return (
                    <FilterString
                        libraryParams={filterLibraryParams}
                        placeholder={placeholder}
                        filter={filter}
                        setFilter={this.setFilter}
                    />
                );
            case DATA_TABLE_FILTER_TYPE_COMPLEX_STRING:
                return (
                    <FilterComplexString
                        libraryParams={filterLibraryParams}
                        placeholder={placeholder}
                        setFilter={this.setFilter}
                        onChange={onChange}
                        filterKey={filterKey ? filterKey : key}
                        filterValue={filterValue}
                        filter={tmpFilter}
                        submitOnKeyPress={submitOnKeyPress}
                        handleSearch={handleSearch}
                    />
                );
            case DATA_TABLE_FILTER_TYPE_DATE:
                return (
                    <FilterDate
                        libraryParams={filterLibraryParams}
                        placeholder={placeholder}
                        setFilter={this.setFilter}
                        filter={filter}
                        operator={operator}
                    />
                );
            case DATA_TABLE_FILTER_TYPE_SELECT:
                return (
                    <FilterSelect
                        libraryParams={filterLibraryParams}
                        placeholder={placeholder}
                        setFilter={this.setFilter}
                        options={options}
                        filter={filter}
                    />
                );
            case DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE:
                return (
                    <FilterAutocomplete
                        libraryParams={filterLibraryParams}
                        placeholder={placeholder}
                        loadOptions={loadOptions}
                        options={options}
                        setFilter={this.setFilter}
                    />
                );
            case DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_MULTI:
                return (
                    <FilterAutocomplete
                        libraryParams={filterLibraryParams}
                        placeholder={placeholder}
                        multi={true}
                        loadOptions={loadOptions}
                        options={options}
                        setFilter={this.setFilter}
                    />
                );
            default:
                return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableFilters/Filter.jsx